import baseURL from '../common/axios';
class Commonservices {

    //To Insert Box-->Inventory API
    insertBox(dataModel) {
        return baseURL.httpMSInventoryUrl.post("BoxMAS/Create", dataModel)
    }
    //To Update Box-->Inventory API
    updateBox(dataModel) {
        return baseURL.httpMSInventoryUrl.post("BoxMAS/Update", dataModel)
    }
    //To Delete Box-->Inventory API
    deleteBox(Id) {
        return baseURL.httpMSInventoryUrl.delete("BoxMAS/Delete?id=" + Id)
    }
    //Active
    active(Id, Status) {
        return baseURL.httpMSInventoryUrl.put("BoxMAS/Active?id=" + Id + "&Status=" + Status + "")
    }
    //To Get Box List-->Inventory API
    getBoxList() {
        return baseURL.httpMSInventoryUrl.get("BoxMAS/List")
    }
    //To Get Box List-->Inventory API
    getBoxById(Id) {
        return baseURL.httpMSInventoryUrl.get("BoxMAS/Get?id=" + Id + "")
    }

}
export default new Commonservices()